export default "__VITE_ASSET__GXD0wBQa__"